// extracted by mini-css-extract-plugin
export default {"modal-duplicate-group-p":"ModalDuplicateGroup_modal-duplicate-group-p__E6+zO","modal-duplicate-group-input":"ModalDuplicateGroup_modal-duplicate-group-input__zf8c-"};